import { time } from '@/time';
import type { Recipe } from '@/types';

const recipe: Recipe = {
  title: 'Japanese Curry',
  source: 'https://www.justonecookbook.com/simple-chicken-curry/',
  totalTime: time(0, 50),
  servings: 8,
  tags: { type: 'sauce' },
  ingredients: [
    { name: 'onions', quantity: '2',
      note: 'large',
    },
    { name: 'carrots', quantity: '2' },
    { name: 'Yukon gold potatoes', quantity: '3' },
    { name: 'ginger', quantity: '1', unit: 'tsp',
      note: 'grated',
    },
    { name: 'garlic', quantity: '2', unit: 'cloves', customUnit: true },
    { name: 'black pepper',
      note: 'freshly ground',
    },
    { name: 'salt',
      note: 'to taste',
    },
    { name: 'neutral oil', quantity: '1 1/2', unit: 'tbsp' },
    { name: 'chicken stock', quantity: '4', unit: 'cup' },
    { name: 'honey', quantity: '1', unit: 'tbsp' },
    { name: 'soy sauce', quantity: '1', unit: 'tbsp' },
    { name: 'Japanese curry roux', quantity: '8', unit: 'oz' },
  ],
  directions: [
    {
      title: 'Prep vegetables',
      bullets: [
        "Cut {onions} into thick wedges",
        "Peel {carrots} & cut into rolling wedges",
        "Peel {Yukon gold potatoes}, quarter & soak in water 15 min",
        "Grate {ginger}",
        "Mince {garlic}"
      ],
    },
    {
      title: 'Build base',
      bullets: [
        "Heat {neutral oil} in large pot over medium heat",
        "Add onions & sauté, stirring occasionally, until translucent & tender, ~5 min",
        "Add garlic & ginger, mix well"
      ],
    },
    {
      title: 'Simmer',
      bullets: [
        "Add {chicken stock}, {honey} & {soy sauce}",
        "Add carrots & potatoes — broth should barely cover ingredients",
        "Bring to boil, then skim scum from surface",
        "Simmer covered on medium-low 15 min, stirring occasionally, until skewer passes through carrots & potatoes",
      ],
    },
    {
      title: 'Add roux',
      bullets: [
        "Turn off heat",
        "Dissolve {Japanese curry roux} 1–2 cubes at a time in a ladleful of cooking liquid, then stir back into pot",
        "Simmer uncovered on medium-low, stirring frequently, until thick, 5–10 min",
        "Thin with water if too thick",
        "If curry roux is unsalted, add {salt} to taste",
      ],
    },
  ],
};

export default recipe;
